import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/arrow-alt-circle-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504C393 504 504 393 504 256S393 8 256 8 8 119 8 256 119 504 256 504zM256 56C366.5 56 456 145.5 456 256S366.5 456 256 456 56 366.5 56 256 145.5 56 256 56zM276 384H236C229.4 384 224 378.6 224 372V256H157C146.3 256 141 243.1 148.5 235.5L247.5 136.5C252.2 131.8 259.8 131.8 264.5 136.5L363.5 235.5C371.1 243.1 365.7 256 355 256H288V372C288 378.6 282.6 384 276 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-up.js
// module id = kxqw
// module chunks = 144